<template>
    <div id="assessmentproxy" class="page_content module_assessment">
        <div>
            <div class="row page-heading border-0">
                <div class="col-8 input module_heading">
                    <span class="icon-assessment float-left"></span>
                    <input
                      type="text"
                      id="title"
                      class="module_title"
                      @blur="$v.title.$touch()"
                      placeholder="Type assessment name*"
					  aria-label="type assessment name"
                      v-model="assessment.title">
                </div>
                <div class="col-4 submit btn-container text-right">
                    <!--<span class="float-right"><span class="fas fa-th"></span></span>-->
                    <button class="btn-cancel" @click="navigateToHome"><span class="icon-cross" aria-label="close"></span></button>
                    <button :class="{disabled: !assessment.title}" class="btn btn-primary" @click.stop="onSubmit(true)" aria-label="done">done</button>
                    <button  :class="{disabled: !assessment.title}"class="btn btn-primary" @click.stop="onSubmit(false)" aria-label="save">save</button>
                </div>
            </div>
            <div class="page-content">
                <div class="row assessment-section">
                   <div class="col-8 assessment-left-section">
                        <div class="page-section">

                            <div class="page_section_row">
                                <div class="heading border-0">
                                    <span for="description" id="AssessmentDescription">Assessment Description</span>
                                </div>
                                <div class="value ml-3">
                                    <textarea rows="4" cols="50"
                                        id="description"
                                        placeholder="Type in the assessment description..."
										aria-labelledby="AssessmentDescription"
                                        v-model="assessment.description">
                                    </textarea>
                                </div>
                            </div>

                            <div class="page_section_row row">
	                            <div class="max-attempts col-6" :class="{invalid: $v.maxAttempt.$error}" >
		                            <div class="heading border-0">
		                                <span for="maxAttempt" id="maximumAttempt">Maximum # of Attempts</span>
		                            </div>
		                            <div class="value pl-0">
		                                <input
		                                    type="number"
		                                    id="maxAttempt"
		                                    @blur="$v.maxAttempt.$touch()"
											aria-labelledby="maximumAttempt"
		                                    v-model.number="assessment.maxAttempt">
		                            </div>
		                        </div>

		                        <div class="max-attempts col-6">
                                    <div class="heading border-0">
                                        <label for="folder" id="folderName">Folder</label>
                                    </div>
                                    <div class="folder-name">
                                        <template v-if="isShowFolderDropDown">
                                            <select id="folder" v-model="owningLibraryId" @change="changeFolder" aria-labelledby="folderName">
                                                <option v-for="folder in folders" :value="folder.uuid">{{ folder.displayName }}</option>
                                            </select>
                                        </template>
                                        <template v-else>
                                            <div class="value">{{ assessment.ancestorName }}</div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="page_section_row row">
                              <div class="max-attempts col-12">
                                <div class="heading border-0">
                                  <label for="manualGradingRubricPdfUri" id="assetUrl">Manual Grading Instruction Document URL</label>
                                </div>
                                <div class="value url pl-0" :class="{invalid: $v.manualGradingRubricPdfUri.$error}" style="width: calc(100% - 40px);">
                                  <input
                                    type="text"
                                    id="manualGradingRubricPdfUri"
                                    placeholder="http://"
                                    v-model.trim="assessment.manualGradingRubricPdfUri"
                                    style="padding-left:8px;">
                                </div>
                              </div>
                            </div>
                            <div class="page_section_row row create">
                              <div class="error max-attempts col-6 ml-2" v-if="!$v.manualGradingRubricPdfUri.url">Invalid document URL.</div>
                            </div>
                        </div>
                    </div>

                    <div class="page_section_row assessment-right-section col-4">
                    	<div class="heading">
                            <span class="ic-tag general mr-2"></span>
                            <span id="assessmentTags">Assessment Tags</span>
                            <span class="icon-pencil2 ml-2" style="cursor: pointer;" @click="showAddTagPopup($event)"></span>
                        </div>
                        <div class="value">
                            <div class="tag-box-list" style="height: 95px !important;">
                                <template v-for="(values, key, i) in appliedTagMap" class="tags_container">
                                    <span class="tag" v-for="(tag, j) in values">
                                        <span class="tag_name instructional_tag ace_sec_txt">{{tag.name}}</span>
                                    </span>
                                </template>
                            </div>
                        </div>
                        <div class="row checkbox_row mt-4">
                          <div class="col-12 checkbox_fld">
                            <input type="checkbox" id="checkbox" aria-labelledby="practiceTest" v-model="assessment.localPractice">
                            <label id="practiceTest">Practice Test</label>
                          </div>
                          <div class="col-12 checkbox_fld">
                            <input type="checkbox" id="checkbox" aria-labelledby="preDiagnosticTest" v-model="assessment.diagonesticTest">
                            <label id="preDiagnosticTest">Pre Diagnostic Test</label>
                          </div>
                          <div class="col-12 checkbox_fld">
                            <input type="checkbox" id="checkbox" aria-labelledby="postDiagnosticTest" v-model="assessment.diagonesticReportTest">
                            <label id="postDiagnosticTest" >Post Diagnostic Test</label>
                          </div>
                        </div>
                        <template>
                            <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
                        </template>
                    </div>
                </div>
				<div class="mt-3">
					<div id="learnosity-author"></div>
				</div>
            </div>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

        <div>
          <data-loss-prompt ref="dataLossAlert" @okLose="okLose" @saveAndContinue="saveAndContinue"></data-loss-prompt>
        </div>

    </div>

</template>

<script>
  /* global LearnosityAuthor:true */
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import AddTagPopup from '../../tagging/components/AddTagPopup'
  import {required, numeric, minValue, url} from 'vuelidate/lib/validators'
  import '../../../assets/module/less/create_entity.less'
  import DataLossPrompt from '../../common/components/DataLossPrompt'
  import _ from 'lodash'
  Vue.use(Vuelidate)

  export default {
    name: 'editAssessment',
    props: ['uuid'],
    components: {
      AddTagPopup,
      DataLossPrompt
    },
    data: () => {
      return {
        authorApp: {},
        assessment: {},
        folders: [],
        ancestor: '',
        owningLibraryId: '',
        isShowFolderDropDown: false,
        appliedTagMap: {},
        taggingEntityData: {},
        isShowTagPopup: false,
        nextPage: undefined,
        dirty: false,
        oldAssessment: {},
        activityItems: []
      }
    },

    validations: {
      title: {
        required
      },
      maxAttempt: {
        required,
        numeric,
        minVal: minValue(1)
      },
      manualGradingRubricPdfUri: {
        url
      }
    },

    beforeRouteLeave (to, from, next) {
      let items = this.authorApp.getActivityItems()
      let itemChanged = !this.isItemsUnchanged(this.activityItems, items)
      if (this.dirty || itemChanged) {
        this.nextPage = next
        this.$refs.dataLossAlert.showPrompt()
        next(false)
      } else {
        next()
      }
    },

    mounted () {
      const userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(userId).then(learningSpaces => {
        this.folders = []
        for (var i = 0; i < learningSpaces.length; i++) {
          const learningSpace = learningSpaces[i]
          const permission = learningSpace.acelist[0].permission
          if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
            this.folders.push(learningSpace)
          }
        }
        var userObject = JSON.parse(localStorage.getItem('userobj'))
        var libraries = userObject.userPreferences.learningSpaces
        if (this.folders.length > 0) {
          this.generateSignedRequest(this.uuid).then(res => {
            if (res) {
              this.assessment = res.assessment
              this.ancestor = this.assessment.ancestor
              this.owningLibraryId = this.assessment.owningLibraryId
              this.isShowFolderDropDown = ($.inArray(this.ancestor, libraries) !== -1)
              if (this.assessment.appliedTagMap) {
                this.appliedTagMap = this.assessment.appliedTagMap
              }
              const signedRequest = JSON.parse(res.signedRequest)
              var eventOptions = {
                readyListener: this.init
              }
              this.authorApp = LearnosityAuthor.init(signedRequest, eventOptions)
              this.$data.oldAssessment = _.cloneDeep(this.$data.assessment)
            }
          })
        }
      })
    },

    methods: {
      ...mapActions([
        'loadLibrariesForUser',
        'generateSignedRequest',
        'saveActivityAtLearnosity'
      ]),

      changeFolder () {
        this.ancestor = this.owningLibraryId
      },

      navigateToHome () {
        return this.$router.push({ name: 'assessmentDetail', params: { uuid: this.assessment.uuid } })
      },

      init () {
        this.authorApp.on('render:activity', (event) => {
          this.activityItems = this.authorApp.getActivityItems()
        }).on('render:itemlist', (event) => {
          $('.lrn-item-list').show()
        })
      },

      showAddTagPopup (event) {
        this.isShowTagPopup = true
        this.taggingEntityData = {title: this.assessment.title, type: 'assets', appliedTagMap: this.appliedTagMap}
        setTimeout(() => {
          this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
        }, 500)
      },

      onSubmit (isDone) {
        this.dirty = false
        this.$refs.loadingModal.show()
        const isSaved = this.authorApp.saveActivity()
        // const appliedTagMap = {general: this.assessmentTags}
        const formData = {
          uuid: this.assessment.uuid,
          title: this.assessment.title,
          description: this.assessment.description,
          maxAttempt: this.assessment.maxAttempt,
          appliedTagMap: this.appliedTagMap,
          ancestor: this.ancestor,
          owningLibraryId: this.owningLibraryId,
          localPractice: this.assessment.localPractice,
          diagonesticTest: this.assessment.diagonesticTest,
          diagonesticReportTest: this.assessment.diagonesticReportTest,
          manualGradingRubricPdfUri: this.assessment.manualGradingRubricPdfUri
        }
        this.saveActivityAtLearnosity(formData).then(res => {
          this.activityItems = this.authorApp.getActivityItems()
          this.$data.oldAssessment = _.cloneDeep(this.$data.assessment)
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Assessment "' + this.assessment.title + '" updated successfully.'
          })
          this.$refs.loadingModal.hide()
          if (isDone) {
            if (this.nextPage) {
              this.$emit('resolveNext', this.nextPage)
            } else {
              return this.$router.push({name: 'assessmentDetail', params: {uuid: this.assessment.uuid}})
            }
          } else {
            if (isSaved) {
              $('.lrn-item-list').hide()
            }
          }
        })
      },

      isItemsUnchanged (arr1, arr2) {
        return ((arr1.length === arr2.length) && arr1.every((item, i) => (item.id === arr2[i].id)))
      },

      okLose () {
        this.$emit('resolveNext', this.nextPage)
      },

      saveAndContinue () {
        this.onSubmit(true)
      }
    },

    watch: {
      assessment: {
        handler () {
          this.dirty = !_.isEqual(this.$data.assessment, this.$data.oldAssessment)
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .proxy-form {
    width: 400px;
    margin: 30px auto;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 3px #ccc;
  }

  .input {
    margin: 10px auto;
  }

  .input label {
    display: block;
    color: #4e4e4e;
    margin-bottom: 6px;
  }

  .input.inline label {
    display: inline;
  }

  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #521751;
    background-color: #eee;
  }

  .input.invalid label {
    color: red;
  }

  .input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }

  .submit button[disabled],
  .submit button[disabled]:hover,
  .submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }

  .icon-assessment {
    font-size:51px;
  }
  .assessment-creator {
    color: #a9a9a9;
  }
  .CLO {
    font-size: 27px;
  }

  .CLO {
     color: #0a558f;
  }
  .icon_autotag {
    font-size:28px;
  }
  .assessment-title {
    margin-top:3px;
  }
  .right-panel {
    height: calc(100vh - 286px);
    overflow-y: auto;
    margin-left: 150px;
  }
  select.form-control:not([size]):not([multiple]) {
    height:auto;
  }
  textarea {
	padding: 7px 11px;
	height: 86px;
  }
  input, .module_title {
	padding-left: 11px;
  }

</style>



// WEBPACK FOOTER //
// src/app/assessment/components/EditAssessment.vue